import { render } from "./MenuItem.vue?vue&type=template&id=1ea81806&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=ts"
export * from "./MenuItem.vue?vue&type=script&lang=ts"

import "./MenuItem.vue?vue&type=style&index=0&id=1ea81806&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ea81806"

export default script